import { useAtomValue, useSetAtom } from 'jotai';
import * as state from '@/components/Analysis/state';
import {
  useSetFocalPointByAssembly,
  useViewpointsByAssembly,
} from '@/components/Analysis/Viewer/hooks';
import { useGetAssemblyDetailsQuery } from '@/__generated__/graphql';
import { Viewpoint } from '@/types';
import { useEffect } from 'react';

const useAssemblyDetails = () => {
  const selectedAssemblyId = useAtomValue(state.selectedAssemblyId);
  const selectedAssemblyName = useAtomValue(state.selectedAssemblyName);
  const setSelectedAssemblyDetails = useSetAtom(state.selectedAssemblyDetails);

  const { data, loading, error } = useGetAssemblyDetailsQuery({
    variables: {
      assemblyId: selectedAssemblyId,
    },
    skip: !selectedAssemblyId,
  });

  useEffect(() => {
    setSelectedAssemblyDetails(() => (loading || error ? undefined : data?.assembly));
  }, [data, loading, error, setSelectedAssemblyDetails]);

  useViewpointsByAssembly(
    selectedAssemblyId,
    (data?.assembly?.seenByViewpoints as Viewpoint[]) ?? undefined
  );
  useSetFocalPointByAssembly(
    selectedAssemblyName,
    data?.assembly?.focalPoint ?? undefined,
    data?.assembly?.cameraPose ?? undefined,
    data?.assembly?.box ?? undefined,
  );

  return {
    assembly: data?.assembly,
    loading,
  };
};

export default useAssemblyDetails;
